import { Link } from "react-router-dom";
import { stockModules } from "../../static/dashboardModules";
import { t } from "../../locales";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "../ui/card";
import { Button } from "../ui/button";
import { useCanAccess } from "../../hooks/useCanAccess";

const StockManagementModules = () => {
  const canAccess = useCanAccess();

  const visibleModules = stockModules.filter((m) => canAccess(m.permission));

  if (visibleModules.length === 0) return null;

  return (
    <section>
      <h2 className="text-base md:text-lg font-semibold text-[#113F67] mb-4">
        {t.dashboard.stockManagementTitle}
      </h2>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {visibleModules.map((module) => {
          const labels = (t.dashboard as Record<string, any>)[module.key] as {
            title: string;
            description: string;
            buttonLabel: string;
          };
          return (
            <Card
              key={module.key}
              className="flex flex-col h-48 sm:h-56 md:h-64 border-2 cursor-pointer transition-all duration-200 hover:shadow-lg hover:scale-105 hover:border-[#34699A]"
            >
              <CardHeader className="text-center pb-2 md:pb-4 px-3 md:px-6 pt-4 md:pt-6">
                <span className="text-2xl md:text-4xl mb-1 md:mb-2">{module.icon}</span>
                <CardTitle className="text-lg md:text-xl font-bold text-[#113F67]">
                  {labels.title}
                </CardTitle>
                <CardDescription className="text-xs md:text-sm text-gray-600 mb-3 md:mb-4 line-clamp-2">
                  {labels.description}
                </CardDescription>
              </CardHeader>
              <CardContent className="text-center flex-1 flex flex-col justify-end px-3 md:px-6 pb-4 md:pb-6">
                <Link to={module.href} className="block">
                  <Button variant="default" size="sm" className="w-full text-sm md:text-base">
                    {labels.buttonLabel}
                  </Button>
                </Link>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </section>
  );
};

export default StockManagementModules;
